import React, { useEffect, useState } from "react";
import Autocomplete from "../common/autoComplete";
import Button from "../common/button";
import "./styles.css";
import halfPageCrossIcon from "../../../src/images/halfPageCrossIcon.svg";
import circleCross from "../../../src/images/circleCross.svg";
import { connect } from "react-redux";
import * as actions from "../../containers/deals/actions";
import DealRadioButton from "../common/DealRadioButton";
import up from "../../../src/images/up.svg";
import down from "../../../src/images/down.svg";
import SeatMap from "../seatMap";
import reverseRoute from "../../../src/images/reverseRoute.svg";

const HalfPagePopup = ({
  props,
  dealTypeCheck,
  isOpen,
  onClose,
  renderElements,
  via_route_support,
  searchButtonStyle,
  getServiceList,
  servicesDataList,
  dataServiceList,
  busDetails,
  dynamicSeatData,
  setDynamicSeatData,
  addBtnClicked,
  seatMapError,
  dealType,
  returnTripDeal,
  addReturnTripDeal,
  addRtripBtnClicked,
  toggleSelectedReturnTripDeal,
  onSelectAllRoundTripDeals
}) => {
  const [serviceNo, setServiceNo] = useState(
    servicesDataList || dataServiceList || []
  );
  const [showViaRoutes, setShowViaRoutes] = useState({});
  const [selectSeat, setSelectSeat] = useState([...props.selectedSeats] || []);
  const [showSeat, setShowSeat] = useState(false);
  useEffect(() => {
    setSelectSeat((prevSelectSeat) => [
      ...prevSelectSeat,
      ...props.selectedSeats,
    ]);
  }, [props.selectedSeats]);

  useEffect(() => {
    const seat = localStorage.getItem("seat_selected");
    const seatData = seat ? JSON.parse(seat) : [];
    // setData(seatData);
    if (selectSeat && selectSeat.length === 0) {
      setSelectSeat(seatData);
    }
  }, []);
  useEffect(() => {//this block to handle seatmap api failure handle
    if(props.dealType === "SEAT_LEVEL" && typeof seatMapError === 'object' && seatMapError !== null && seatMapError.isError === true) {
      setShowSeat(false);
    }
  }, [seatMapError])

  const toggleViaRoutes = (index) => {
    setShowViaRoutes((prevRoute) => ({
      ...prevRoute,
      [index]: !prevRoute[index],
    }));
  };

  const serviceAddedHandler = async (el) => {
    setShowSeat(true);
    setServiceNo((prevServiceNo) => {
      const isPresent = prevServiceNo.some((item) => item.id === el.id);
      if (isPresent) {
        return prevServiceNo.filter((item) => item.id !== el.id);
      } else {
        return prevServiceNo.concat(el);
      }
    });
  };

  const onCancelClick = (el) => {
    setServiceNo((prevServiceNo) => {
      const updatedServiceNo = prevServiceNo.filter(
        (item) => item.id === el.id
      );
      return updatedServiceNo;
    });
    const updatedSeatData =
      dynamicSeatData &&
      Object.entries(dynamicSeatData).filter(([key]) => key !== el.id);
    setDynamicSeatData(updatedSeatData);
    setShowSeat(false);
  };

  const onAddSeatClick = (el) => {
      setShowSeat(false);
  };

  const clearSelectedService = (el) => {
    setServiceNo((prevServiceNo) => {
      const isPresent = prevServiceNo.some((item) => item.id === el.id);
      if (isPresent) {
        return prevServiceNo.filter((item) => item.id !== el.id);
      }
    });
  };

  const addSelectedButtonClick = () => {
    if(props.dealType === "RETURN_TRIP") {
      addRtripBtnClicked(true);//Same bus For Different Route
      onClose(true);
      return;
    }
    if (props.isEditCase && props.dealType === "SEAT_LEVEL") {
      if (props.seatSelected.length === 0) {
        alert("Please select Seat");
        return;
      }
    } else if (!props.isEditCase && props.dealType === "SEAT_LEVEL") {
      if (props.selectedSeats.length === 0) {
        alert("Please select Seat");
        return;
      }
    }

    let serviceList = [];
    const updatedServiceList = [...serviceList, ...serviceNo];
    getServiceList(updatedServiceList);
    localStorage.setItem(
      "service_List",
      JSON.stringify(updatedServiceList || [])
    );
    localStorage.setItem("source", JSON.stringify(props.source || ""));
    localStorage.setItem(
      "destination",
      JSON.stringify(props.destination || "")
    );
    localStorage.setItem(
      "seat_selected",
      JSON.stringify(props.selectedSeats || [])
    );
    onClose();
    addBtnClicked(true);//Same bus For Different Route
  };

  const onSelectAllHandler = () => {
    let filteredServicesDataList = [];
    if (servicesDataList && servicesDataList.length > 0) {
      filteredServicesDataList = servicesDataList.filter(
        (service) => !props.routeServices.includes(service)
      );
    }
    const updatedServiceNo = filteredServicesDataList.concat(
      props.routeServices
    );
    props.selectAllClicked(updatedServiceNo);
    setServiceNo(updatedServiceNo);
  };

  const onClearAllHandle = () => {
    props.selectAllClicked([]);
    setServiceNo([]);
  };

  const handleSearchClick = (index = -1) => {   
    if(index !== -1) {
      props.onSearchClick(dealType === "RETURN_TRIP" ? true : false, returnTripDeal[index], true, (services) => addReturnTripDeal(services, index));
    }
    else {
      props.onSearchClick(dealType === "RETURN_TRIP" ? true : false, null, false, addReturnTripDeal); 
    }
    addBtnClicked(false);//Same bus For Different Route
  }

  const selectAllStyle = {
    color: returnTripDeal.some(returnTrip => !returnTrip.isSelected) ? '#00B8F5' : 'rgba(16, 16, 16, 0.22)'
  }

  return (
    <div className="HalfPagePopup">
      <div className={`half-page-popup ${isOpen ? "open" : ""}`}>
        <div className="popup-content">
          <img className="cross" src={halfPageCrossIcon} onClick={onClose} alt="close"/>
          <div className="specificRoutes">Select specific route</div>
          {
            <React.Fragment>
              <div className="searchContainer">
                <div className="searchinput deal-padding-right deal-textfield">
                  <Autocomplete
                    name="source"
                    openOnFocus={true}
                    placeholder="Enter source"
                    isDisabled={props.isEditCase}
                    onSelect={(data) => {
                      props.onSourceItemSelect(data);
                      addBtnClicked(false);//Same bus For Different Route
                    }}
                    defaultValue={props.source}
                    fieldName="source"
                    onChange={props.fetchCities}
                    renderElements={renderElements}
                    listData={props.sourceCityData}
                    shouldHideCrossIcon
                  />
                </div>
                <div className="searchinput deal-textfield deal-padding-right">
                  <Autocomplete
                    openOnFocus={true}
                    name="destination"
                    placeholder="Enter destination "
                    isDisabled={props.isEditCase}
                    onSelect={(data) => { 
                      props.onDestinationItemSelect(data);
                      addBtnClicked(false);//Same bus For Different Route
                    } }
                    defaultValue={props.destination}
                    fieldName="destination"
                    onChange={props.fetchCities}
                    renderElements={renderElements}
                    listData={props.destCityData}
                    shouldHideCrossIcon
                  />
                </div>
                {via_route_support && (
                  <div className="col-xs-3 checkbox viaRoute">
                    <input
                      type="checkbox"
                      id="inventory_refresh_checkbox"
                      checked={props.inventoryRefreshCheckbox}
                      onClick={props.onInventoryRefreshCheckBox}
                      disabled={serviceNo.length > 0 ? true : false}
                    />
                    <label
                      onClick={
                        serviceNo.length === 0 &&
                        props.onInventoryRefreshCheckBox
                      }
                      className="checkbox"
                    >
                      Include via routes
                    </label>
                  </div>
                )}
                {!props.isEditCase && (props.dealType === "SEAT_LEVEL" ? !showSeat || !serviceNo ||
                          serviceNo.length === 0   : true ) &&  (
                  <div className="searchBtn">
                    <Button
                      styleObj={searchButtonStyle}
                      label="+ Add"
                      onButtonClick={() => handleSearchClick()}
                    />
                  </div>
                )}
              </div>
            </React.Fragment>
          }
        </div>

        { /* onward */ }

      {
        dealType === "RETURN_TRIP" && returnTripDeal.length ? (
      <div className="bodyContainer">
        <table>
          <thead>
            <tr>
              <th>
                Onward Route (Offer visible)
                <span onClick={onSelectAllRoundTripDeals} style={selectAllStyle}> Select All</span>
              </th>
              <th className="returnRoutesTitle">
                Return Route <span>(Offer Applied)</span>
              </th>
            </tr>
          </thead>
          <tbody>
            {returnTripDeal.map((el, index) => (
              <tr key={index} className="routesText">
                <td>
                  <DealRadioButton
                    label={`${el.source.city_name} - ${el.destination.city_name}`}
                    isChecked={el.isSelected}
                    onSelectionChange={async (isChecked) => {
                      toggleSelectedReturnTripDeal(index);
                    }}
                    dealChanges
                    isReturnTripDeal
                  />
                </td>
                <td>
                  <div key={index} className="rTripServiceTextContainer">
                    <div style={{ color: el.isSelected ? '#21C179': '#dcdcdc' }} className="reverseRouteDisplay">{`${el.destination.city_name} - ${el.source.city_name}`}</div>
                    {el.isReverseRoute && (
                      <button className="reverseBtn" onClick={() => handleSearchClick(index)}>
                        <img src={reverseRoute} alt='' />
                        Add Reverse
                      </button>
                    )}
                  </div>
                </td>
              </tr>
            ))}
            <tr>
              <td colspan="2">
                <div className="addSelectedBtn" onClick={() => addSelectedButtonClick()}>
                  <div>Add Selected Route</div>
                </div>
              </td>
            </tr>
          </tbody>
        </table> 
      </div>
        ) : null
      }

        {dealType !== 'RETURN_TRIP' && props.routeServices.length ? (
          <React.Fragment>
            <div className= {(showSeat && props.dealType === "SEAT_LEVEL") ? "borderBlockMargin" : "borderBlock"}>
              <div className="serviceBorder">
                <div>
                  <div className="deal-services-wrp">
                    <div className="selectService">
                      <p className="marginTop20 serviceAdded">
                        Select services to add
                      </p>
                      {props.dealType !== "SEAT_LEVEL" && (
                        <div
                          className="selectBtn"
                          onClick={() => {
                            onSelectAllHandler();
                          }}
                        >
                          Select All
                        </div>
                      )}
                    </div>

                    {props.routeServices.map((el, index) => (
                      <div key={index}>
                        <div key={index} className="serviceText">
                          <DealRadioButton
                            label={`${el.departure_datetime}, ${el.bus_type_name}`}
                            isChecked={serviceNo
                              .map((elm) => elm.id)
                              .includes(el.id)}
                            onSelectionChange={async (isChecked) => {
                              if (props.dealType === "SEAT_LEVEL") {
                                !showSeat &&
                                  props.onSearvicesSelection(
                                    el.id,
                                    isChecked,
                                    props.dealType,
                                    el
                                  );
                              }
                              if (props.dealType === "SEAT_LEVEL") {
                                !showSeat && (await serviceAddedHandler(el));
                              } else {
                                await serviceAddedHandler(el);
                              }
                            }}
                            dealChanges
                          />
                        </div>

                        {props.dealType === "SEAT_LEVEL" &&
                          serviceNo &&
                          serviceNo.length !== 0 &&
                          (showSeat || seatMapError.isError) && (
                            <div className="seatMap">
                              <div className="header"><div className="seatHeader">
                                Select Seats..{" "}
                                <span className="note">
                                  *It is mandatory to select seats to create
                                  seat level deals
                                </span>
                              </div><div className="buttonsSection">
                                {
                                  <div
                                    className="seatAdd"
                                    onClick={() => onAddSeatClick(el)}
                                  >
                                    Add Service
                                  </div>
                                }

                                <div
                                  className="seatCancel"
                                  onClick={() => onCancelClick(el)}
                                >
                                  Cancel
                                </div>
                              </div></div>
                              
                              <SeatMap
                                seatMap={props.seatMap}
                                seatMapError={props.seatMapError}
                                busDetails={busDetails}
                                selectedSeats={
                                  props.isEditCase
                                    ? props.seatSelected
                                    : props.selectedSeats
                                }
                                selectSeatHandler={props.selectSeatHandler}
                                getSeat={props.getSeat}
                                onSearvicesSelection={
                                  props.onSearvicesSelection
                                }
                                dataServiceList={dataServiceList}
                                dealType={props.dealType}
                                isEdit={props.isEditCase}
                                dynamicSeatData={dynamicSeatData}
                                setDynamicSeatData={setDynamicSeatData}
                              />
                              
                            </div>
                          )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="serviceAddBorder">
                <div className="marginTop20 serviceAdded">
                  {serviceNo.length} services added
                  <div className='clearAll' onClick={() => onClearAllHandle()}>
                    Clear All
                 </div>
                </div>
                {serviceNo.length > 0 &&
                  serviceNo.map((el, index) => {
                    const viaRoutesData =
                      props.routeServices.filter((elem) => elem.id === el.id) ||
                      [];
                    return (
                      <div>
                        <div className="serviceTextContainer">
                          <div
                            key={index}
                            className="serviceTextData priyankabhadra"
                          >
                            <div className="elipse">
                              {(el && el.source)}-
                              {(el && el.destination)}-
                              <span className="elipseSpan">
                                {(el && el.departure_datetime) || ""},
                                {(el && el.bus_type_name) || ""}
                              </span>
                            </div>
                          </div>
                          <img
                            src={circleCross}
                            className="circleCross"
                            alt="circleCross"
                            onClick={() => {
                              clearSelectedService(el);
                              props.onSearvicesSelection(
                                el.id,
                                false,
                                props.dealType,
                                el
                              );
                            }}
                          />
                        </div>

                        {props.inventoryRefreshCheckbox &&
                          el &&
                          el.via_routes &&
                          el.via_routes.length > 0 && (
                            <div
                              className="seeHideBtn"
                              onClick={() => toggleViaRoutes(index)}
                            >
                              {!showViaRoutes[index] ? (
                                <>
                                  See Via Route <img src={up} />
                                </>
                              ) : (
                                <>
                                  Hide Via Routes <img src={down} />
                                </>
                              )}
                            </div>
                          )}

                        {props.inventoryRefreshCheckbox &&
                          showViaRoutes[index] &&
                          viaRoutesData &&
                          viaRoutesData.map((elem, index) => {
                            return (
                              elem.via_routes &&
                              elem.via_routes.length > 0 &&
                              elem.via_routes.map((vdata, index) => {
                                return (
                                  <div>
                                    {(props.inventoryRefreshCheckbox ||
                                      showViaRoutes) && (
                                      <div className="vDataBlock">
                                        <div className="vDataText">{`${vdata.route},  ${vdata.route_name}`}</div>
                                      </div>
                                    )}
                                  </div>
                                );
                              })
                            );
                          })}
                      </div>
                    );
                  })}
              </div>
            </div>
            {serviceNo.length > 0 ? (
              <div
                className="addSelectedBtn"
                onClick={() => addSelectedButtonClick()}
              >
                <div>Add Selected Route</div>
              </div>
            ) : (
              <div className="addSelectedBtnDeactivate">
                <div>Add Selected Route</div>
              </div>
            )}
          </React.Fragment>
        ) : null}
      </div>
    </div>
  );
};

const mapStateToProps = (store) => ({
  servicesDataList: store.dealsReducer.servicesDataList,
  busDetails: store.dealsReducer.busDetails,
  dynamicSeatData: store.dealsReducer.dynamicSeatData,
  seatMapError: store.dealsReducer.seatMapError
});

const mapDispatchToProps = (dispatch) => ({
  getServiceList: (servicesDataList) =>
    dispatch(actions.getServiceList(servicesDataList)),
  setDynamicSeatData: (seatData) =>
    dispatch(actions.setDynamicSeatData(seatData)),
    addBtnClicked: (flag) =>
    dispatch(actions.addBtnClicked(flag)),
  // getAllRoutesInfo: () => dispatch(actions.getAllRoutesInfo())
});

export default connect(mapStateToProps, mapDispatchToProps)(HalfPagePopup);
